module.exports = __webpack_public_path__ + "img/logout.3c5efa18.svg";